import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import
{
    Box,
} from '@mui/material';
import { generatePath } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Helper from '../../utility/helper';
import { useEventState } from '../../stores/eventStore';
import { useAuthState } from '../../stores/authStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import DataList from '../../sharedcomponents/dataList/dataList';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const SatNightTransportList = (props) =>
{
    const authState = useAuthState();
    const loading = useState(false);
    const eventState = useEventState();
    const transportList = useState([]);
    const selectedEvent = useState(null);
    const setAll = useState(false);
    const userID = useState(null);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);

    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (selectedEvent.get() == null || selectedEvent.get())
        {
            if (eventState && eventState.eventDetail.get())
            {
                if (
                    selectedEvent.get() == null ||
                    eventState.eventDetail.get().eventID !=
                    selectedEvent.get().eventID
                )
                {
                    if (!Helper.isAdminUser(userInfo))
                    {
                        const permissions = eventState.permissions.attach(Downgraded).get();
                        console.log('permissions : ', permissions);
                        if (permissions && permissions.length > 0)
                        {
                            setModPermission(Helper.getModuleAccessPermission(permissions, 'SATNIGHTTRANSPORT'));
                        }
                    }
                    else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
                    {
                        setModPermission(FULL_PERMISSION)
                    }
                    selectedEvent.set(
                        eventState.eventDetail.attach(Downgraded).get()
                    );
                }
            }
            // else {
            //     const eventInfo = Helper.getStorage('eventInfo');
            //     if (
            //         selectedEvent.get() == null ||
            //         selectedEvent.get().eventID != selectedEvent.get().eventID
            //     ) {
            //         selectedEvent.set(eventInfo);
            //     }
            // }
        }
    }, [eventState]);

    useEffect(() =>
    {
        const fetch = async () =>
        {
            const userInfo = Helper.getStorage('userInfo');
            userID.set(userInfo.userID);
            const authStateInfo = authState
                .nested('appDetails')
                .attach(Downgraded)
                .get();
            if (
                authState &&
                authStateInfo &&
                authStateInfo.itemsPerPage &&
                pagingInfo.get().itemsPerPage == null &&
                modPermission && modPermission != NO_ACCESS_PERMISSION
            )
            {
                pagingInfo.set({
                    ...pagingInfo,
                    currentPage: 1,
                    itemsPerPage: authStateInfo.itemsPerPage,
                    noOfPages: null,
                });
                const eventDetail = selectedEvent.attach(Downgraded).get();
                if (eventDetail && eventDetail.eventID)
                {
                    console.log('modPermission : ', modPermission);
                    //getTransportRequests();
                }
            }

        }
        fetch();
    }, [authState, modPermission]);

    useEffect(() =>
    {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION)
        {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage)
            {
                getTransportList();
            }
            // getParticipantList();
        }
    }, [modPermission]);

    const getTransportList = () =>
    {
        loading.set(true);
        let participantList = [];
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_USER_SAT_NIGHT_TRANSPORT_LIST(
                gEventInfo.eventID,
                userID.get(),
                pagingInfo.get().currentPage,
                pagingInfo.get().itemsPerPage
            )
        )
            .then((res) =>
            {
                if (res.data.rows)
                {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0)
                    {
                        data.map((item) =>
                        {
                            if (
                                participantList.indexOf(item.participant) == -1
                            )
                            {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'transportID',
                                        transportID: item.transportID,
                                        width: '0.05',
                                    },
                                    {
                                        label: 'Pickup Time',
                                        key: 'pickupDate',
                                        pickupDate: Helper.FormatDateTime(item.pickupDate),
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Pickup Address',
                                        key: 'pickupAddress',
                                        pickupAddress: item.pickupAddress,
                                        width: '0.15',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'DropOff Address',
                                        key: 'dropOffAddress',
                                        dropOffAddress: item.dropOffAddress,
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Pri Contact Name',
                                        key: 'priContactName',
                                        priContactName: item.priContactName,
                                        width: '0.1',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Pri Contact Email',
                                        key: 'priContactEmail',
                                        priContactEmail: item.priContactEmail,
                                        width: '0.15',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Backup Contact Name',
                                        key: 'backupContactName',
                                        backupContactName: item.backupContactName,
                                        width: '0.1',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Backup Contact Email',
                                        key: 'backupContactEmail',
                                        backupContactEmail: item.backupContactEmail,
                                        width: '0.15',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.05',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'editnote',
                                        editnote: item.note,
                                        width: '0.05',
                                    },
                                ],
                                selected: false,
                            });
                        });

                    }
                    transportList.set(requestData);
                }
                loading.set(false);
            })
            .catch((error) =>
            {
                loading.set(false);
                if (error.response && error.response.status === 401)
                {
                    alert(error);
                }
            });
    }
    const redirectToTransit = (row) =>
    {
        const path = generatePath(RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_EDIT, {
            eventID: row.actualData.eventID,
            transitID: row.actualData.transportID,
        });
        console.log('actualdata : ', row.actualData);
        props.history.push({
            pathname: path,
            state: {
                transportState: row.actualData
            }
        });
    }

    const handleClick = () =>
    {
        const gEventInfo = Helper.getStorage('eventInfo');
        const path = generatePath(RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_CREATE, {
            eventID: gEventInfo.eventID
        });
        props.history.push({
            pathname: path,
            state: {
            }
        });
    }

    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getTransportList();
    };
    const deleteRows = () =>
    {
        const selected = transportList.get().filter((row) => row.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }

    const handleConfirmation = () =>
    {
        let deleteRequests = [];
        transportList.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.transportID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_SATNIGHT, {
            Ids: deleteRequests.join(','),
            Delete: true,
            ModifiedBy: userID.value,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    // onDelete(false);
                    setAll.set(false);
                    getTransportList();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                // className="otherContentBox"
                sx={{
                    // p: 2,
                    '& .MuiGrid-item': { p: 2 },
                    '& .MuiFormControl-root': { width: '100%' },
                }}>
                {loading.get() ? (
                    <Box style={loader}>
                        <CircularProgress />
                    </Box>
                ) :
                    modPermission && modPermission == NO_ACCESS_PERMISSION ?
                        <UnauthorizedUI showLogout={false} />
                        :
                        transportList.get() ? (
                            <DataList
                                data={transportList.attach(Downgraded).get()}
                                editRow={redirectToTransit}
                                handleClick={handleClick}
                                title={''}
                                buttonTitle={'Add'}
                                deleteRows={deleteRows}
                                //hideDelete={true}
                                showSearch={true}
                                searchLabel={'Search'}
                                showSearchRec={showSearchRec}
                                setShowSearchRec={setShowSearchRec}
                                pagingInfo={pagingInfo.attach(Downgraded).get()}
                                handlePageChange={handlePageChange}
                                moduleToShow={"Saturday Night Transportation"}
                                modPermission={modPermission}
                                titleHeader='SatNightTransport'
                            />
                        ) : null}


                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
                {
                    <ConfirmationDialog
                        open={deleteConfirmation.get().open}
                        message={deleteConfirmation.get().message}
                        OkButtonText={deleteConfirmation.get().OkButtonText}
                        handleCnfClick={() =>
                            handleConfirmation(deleteConfirmation)
                        }
                        onCancelClick={() =>
                        {
                            deleteConfirmation.set({
                                ...deleteConfirmation.get(),
                                open: false,
                            });
                        }}></ConfirmationDialog>
                }
            </Box>
        </Box>
    )
}

export default {
    routeProps: {
        path: RouteConstants.EVENT_SAT_NIGHT_TRANSPORT,
        component: SatNightTransportList,
    },
    name: 'SatNightTransportList',
};